import React from 'react'
type SparkdefaultIconPropTypes = {
  height?: string | number
  width?: string | number
}
function SparkdefaultIcon({
  height = '60',
  width = '60',
}: SparkdefaultIconPropTypes) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 27 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.622 3.67154L15.3476 8.15797C15.6282 8.88755 15.7685 9.25234 15.9867 9.55919C16.1801 9.83114 16.4177 10.0687 16.6896 10.2621C16.9965 10.4803 17.3612 10.6206 18.0908 10.9012L22.5773 12.6268L18.0908 14.3523C17.3612 14.6329 16.9965 14.7732 16.6896 14.9914C16.4177 15.1848 16.1801 15.4224 15.9867 15.6943C15.7685 16.0012 15.6282 16.366 15.3476 17.0956L13.622 21.582L11.8965 17.0956C11.6159 16.366 11.4756 16.0012 11.2574 15.6943C11.064 15.4224 10.8264 15.1848 10.5545 14.9914C10.2476 14.7732 9.88282 14.6329 9.15324 14.3523L4.66681 12.6268L9.15324 10.9012C9.88282 10.6206 10.2476 10.4803 10.5545 10.2621C10.8264 10.0687 11.064 9.83114 11.2574 9.55919C11.4756 9.25234 11.6159 8.88755 11.8965 8.15797L13.622 3.67154Z'
        fill='white'
      />
    </svg>
  )
}

export default SparkdefaultIcon
